import { render, staticRenderFns } from "./WindowBar.vue?vue&type=template&id=3c05b77c&"
import script from "./WindowBar.vue?vue&type=script&lang=js&"
export * from "./WindowBar.vue?vue&type=script&lang=js&"
import style0 from "./WindowBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VIcon,VSpacer,VSystemBar})
